import { IndicatorFactType } from '@/api/rest/resources/types/fact';
import { GraphTileType } from '@/api/rest/resources/types/widget';
import { useIndicatorProduct } from '@/hooks/useIndicatorProduct';

import { availableGraphsToIndicatorNames } from '../constants';

export const useAllowedGraphTypes = (indicators?: IndicatorFactType[]): GraphTileType[] => {
  const purchasedIndicatorProducts =
    useIndicatorProduct({
      purchased: true,
      visible_for_customer: true,
    }).data ?? [];

  return Object.entries(availableGraphsToIndicatorNames).reduce<GraphTileType[]>((acc, [graphType, factType]) => {
    const isSubscribed = purchasedIndicatorProducts.some((p) => p.indicator_names.includes(factType));
    const isSelectedIndicator = indicators ? indicators.includes(factType) : true;
    if (isSubscribed && isSelectedIndicator) {
      acc.push(graphType as GraphTileType);
    }
    return acc;
  }, []);
};
